function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkFilled = function SvgBookmarkFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "actions/bookmark-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 2C5.25 1.58579 5.58579 1.25 6 1.25H17.7647C18.1789 1.25 18.5147 1.58579 18.5147 2V22C18.5147 22.2883 18.3494 22.5511 18.0896 22.676C17.8297 22.8009 17.5213 22.7658 17.2962 22.5857L11.8824 18.2546L6.46852 22.5857C6.24339 22.7658 5.93496 22.8009 5.67511 22.676C5.41526 22.5511 5.25 22.2883 5.25 22V2Z",
    fill: "currentColor"
  })));
};
SvgBookmarkFilled.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgBookmarkFilled"
};
export default SvgBookmarkFilled;